<!-- START Top Navbar-->
<nav class="navbar topnavbar navbar-expand-lg navbar-light" role="navigation">
  <!-- START navbar header-->
  <!--<div class="navbar-header">
    <a class="navbar-brand" href="#/">
      <div class="brand-logo">
        <img class="img-fluid" src="assets/img/logo.png" alt="App Logo" />
      </div>
      <div class="brand-logo-collapsed">
        <img class="img-fluid" src="assets/img/logo-single.png" alt="App Logo" />
      </div>
    </a>
    <button class="navbar-toggler" type="button" (click)="navCollapsed = !navCollapsed; $event.stopPropagation()">
      <span class="navbar-toggler-icon"></span>
    </button>
  </div>-->

  <div class="header-logo">
    <div>
      <a class="logo">
        <img src="/assets/img/logo.png" style="width: 100%;">
      </a>
      <div class="desc">
    <div class="desc__title1">EDUNO</div>
    <h1 class="desc__title__main"></h1>
  </div>

      

    </div>
    <button class="navbar-toggler" type="button" (click)="navCollapsed = !navCollapsed; $event.stopPropagation()">
      <span class="navbar-toggler-icon"></span>
    </button>
  </div>
  
  <!-- END navbar header-->
  <!-- START Nav wrapper-->
  <div class="navbar-collapse collapse" [collapse]="navCollapsed">
    <!-- Navbar Menu -->
    <ul class="nav navbar-nav mr-auto flex-column flex-lg-row">
      <li  class="nav-item active">
        <a 
           class="nav-link"
           style="flex-direction: row"
           title="Học online"
           [routerLink]="'/dashboard'">
          <em  class="fa-13x fa-chalkboard fas pd-b-3"></em><!---->
          <span  style="margin-left: 10px">Trang chủ</span>
        </a>
      </li>
      <li  class="nav-item">
        <a 
           class="nav-link"
           style="flex-direction: row"
           title="Khóa học"
           [routerLink]="'/dieuhanh/khoahoc'">

          <em  class="fa fa-13x fa-cube pd-b-3"></em><!---->
          <span  style="margin-left: 10px">Lớp học</span>
        </a>
      </li>
      <li  class="nav-item">
        <a 
           class="nav-link"
           style="flex-direction: row"
           title="Sổ liên lạc"
           [routerLink]="'/dieuhanh/solienlacview'">
          <em  class="fa-13x fa-comments far pd-b-3"></em><!---->
          <span  style="margin-left: 10px">Sổ liên lạc</span>
        </a>
      </li>


    </ul>
    <!-- End Navbar Menu-->
    <!-- START Right Navbar-->
    <ul class="navbar-nav flex-row navbar-right">
      <!--<li class="nav-item">
    <a class="nav-link" title="Trang thông tin" href="/#/thong-tin">
      <em class="fa-13x mr-2 fas fa-eye"></em>
      {{'Trang thông tin' | translate}}
    </a>
  </li>-->
      <li class="nav-item" [hidden]="giang_vien=='0'">
        <a class="nav-link" title="Quản lý" href="/#/home">
          <em class=" mr-2 fab fa-delicious"></em>
          {{'Quản lý' | translate}}
        </a>
      </li>

      <li class="nav-item" style="display: flex;">
        <div class="language-container">
          <div class="language-option" [ngClass]="{'language-select': ngon_ngu==1}" (click)="ChonNgonNgu(1)">
            <img src="/assets/img/Flag_of_Vietnam.svg" class="flag" alt="Vietnam Flag" (click)="ChonNgonNgu(1)">
          </div>
          <div class="language-option" [ngClass]="{'language-select': ngon_ngu==2}" (click)="ChonNgonNgu(2)">
            <img src="/assets/img/Flag_of_the_United_Kingdom.svg" class="flag" alt="UK Flag" (click)="ChonNgonNgu(2)">
          </div>
        </div>
      </li>

      <li class="nav-item dropdown dropdown-list" dropdown>
        <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" dropdownToggle style="flex-direction:row;">
          <em class="fa-13x mr-2 fas fa-user-circle" style="color:#fff;"></em>
          {{username}}
        </a>
        <!--<ul *dropdownMenu class="dropdown-menu dropdown-menu-right animated flipInX">

    </ul>-->
        <!-- START Dropdown menu-->
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right animated flipInX">
          <li>
            <!-- START list group-->
            <div class="list-group">


              <a class="list-group-item" [routerLink]="['/dieuhanh/profile']">
                <div class="media">
                  <div class="align-self-start mr-2">
                    <i class="far fa-address-card"></i>
                  </div>
                  <div class="media-body clearfix">
                    <p class="m0">Cá nhân</p>
                    <p class="m0 text-muted">
                      <small>Thông tin cá nhân...</small>
                    </p>
                  </div>
                </div>
              </a>
              <a class="list-group-item" [routerLink]="['/quantri/doimatkhau']">
                <div class="media">
                  <div class="align-self-start mr-2">
                    <i class="fa fa-exchange"></i>
                  </div>
                  <div class="media-body clearfix">
                    <p class="m0">Đổi mật khẩu</p>
                    <p class="m0 text-muted">
                      <small>Thay đổi mật khẩu tài khoản</small>
                    </p>
                  </div>
                </div>
              </a>
              <a class="list-group-item" (click)="logout()">
                <div class="media">
                  <div class="align-self-start mr-2">
                    <i class="fa fa-external-link"></i>
                  </div>
                  <div class="media-body clearfix">
                    <p class="m0">Đăng xuất</p>
                    <p class="m0 text-muted">
                      <small>Thay tài khoản</small>
                    </p>
                  </div>
                </div>
              </a>



            </div>
            <!-- END list group-->
          </li>
        </ul>
        <!-- END Dropdown menu-->
      </li>
     
    </ul>
    <!-- END Right Navbar-->
  </div>
  <!-- END Nav wrapper-->

</nav>
<!-- END Top Navbar-->
